module.exports = __webpack_public_path__ + "assets/language-squares/es-47aae8dd9f1e453015f9d2d568b9e45d.jpg";